import styled from 'styled-components';
import { textTransform } from 'utils';

export const NewsletterWrapper = styled.div.attrs({
  className: 'newsletter-wrapper'
})`
  h2 {
    font-weight: 450;
    font-size: 24px;
    line-height: 34px;
    letter-spacing: 1.5px;
    text-transform: ${textTransform};
  }

  h3 {
    font-weight: 390;
    font-size: 16px;
    line-height: 24px;
    margin-top: 98px;
  }

  .newsletter-wrapper__data-divider {
    border: 3px solid rgba(151, 151, 151, 0.8);
    margin-top: 90px;
  }

  .newsletter-wrapper__input-wrapper {
    margin-top: 40px;

    .newsletter-wrapper__input-container {
      margin-top: 18px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .newsletter-wrapper__input-reg-s {
        width: 288px;
        margin: 16px 23px 0 0;
      }

      .newsletter-wrapper__input-reg {
        width: 288px;
        margin-top: 16px;
      }

      .newsletter-wrapper__input-dual {
        display: flex;
        width: 50%;
      }

      .newsletter-wrapper__input-lng {
        width: 50%;
        margin-top: 16px;
      }
    }

    .newsletter-wrapper__checkbox-wrapper {
      margin-top: 77px;

      .newsletter-wrapper__input-checkbox {
        display: flex;
        align-items: center;
        margin-top: 16px;
        padding: 0;
        cursor: pointer;
        color: #ffffff;

        h3 {
          font-size: 18px;
          margin: 0 0 0 10px;
        }

        .newsletter-wrapper__terms-link {
          text-decoration: underline;
        }
      }
    }

    .newsletter-wrapper__required-fields {
      margin-top: 39px;
    }
  }

  .newsletter-wrapper__register-divider {
    border: 3px solid rgba(151, 151, 151, 0.8);
    margin-top: 26px;
  }

  .newsletter-wrapper__register-btn {
    margin: 39px 0 100px;

    .register-btn {
      width: 228px;
    }
    .captcha{
      margin: 0 auto;
      margin-bottom: 4rem;
    }
  }
`;

export const Title = styled.h1`
  display: inline-block;
  vertical-align: middle;
  font-size: 2.4rem;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: ${textTransform};
  color: ${({ theme }) => theme.color.textPrimary};
  margin: 29px 0 30px 0;
`;
